<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        item-text="nazev"
        v-model="selectedItem"
        label="Vyberte dodavatele"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2 mt-0"
        :rules="rules"
        :disabled="disabled"
      >
      </v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      selectedItem: null
    }
  },
  props: {
    produkt: Number,
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Number,
    all: Boolean,
    disabled: Boolean,
    dodavatele: Array,
    metal_konto: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedItem (v) {
      this.$emit("input", v.id);
      this.$emit("changed", v);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      if (typeof this.dodavatele !== "undefined" && this.dodavatele != null) {
        var metal_konto = this.metal_konto;
        this.items = this.dodavatele.filter((x) => { return x.ma_metal_konto == metal_konto; });
        if (this.value != null) {
          var dodavatel_id = this.value;
          var $f = this.items.filter((x) => { return x.id == dodavatel_id; });
          if ($f.length > 0)
            this.selectedItem = $f[0];
          else
            this.selectedItem = null;
        }
        else {
          this.selectedItem = null;
        }
      }
      else {
        window.api.get("produkty/" + this.produkt + "/dodavatele").then(function(_body) {
          this.items = _body;
          if (this.value != null) {
            var dodavatel_id = this.value;
            var $f = this.items.filter((x) => { return x.id == dodavatel_id; });
            if ($f.length > 0)
              this.selectedItem = $f[0];
            else
              this.selectedItem = null;
          }
          else {
            this.selectedItem = null;
          }
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/DodavateleProduktuSelect.vue